import React from 'react';
import { motion } from 'framer-motion';
export function ProblemSection() {
  const painPoints = ["You haven't showered alone in weeks.", 'You feel anxious before every nap.', "You're stuck on the couch for hours.", 'Every transfer fails.', 'You love your baby… but you feel completely trapped.'];
  return <section id="validation" className="relative py-16 md:py-24 px-6 md:px-8 bg-cream-dark overflow-hidden" data-id="element-511">
      {/* Subtle ambient glow */}
      <div className="absolute top-1/3 left-1/2 -translate-x-1/2 w-[400px] h-[400px] bg-terracotta/4 rounded-full blur-[100px] pointer-events-none" data-id="element-512" />

      <div className="max-w-3xl mx-auto relative" data-id="element-513">
        {/* Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8,
        ease: [0.25, 0.1, 0.25, 1]
      }} className="text-center mb-14 md:mb-16" data-id="element-514">
          <h2 className="font-serif text-3xl md:text-5xl text-brown leading-tight" data-id="element-515">
            If This Is You…
          </h2>
        </motion.div>

        {/* Pain points */}
        <div className="space-y-4 md:space-y-5 mb-14 md:mb-16 max-w-2xl mx-auto" data-id="element-516">
          {painPoints.map((pain, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.6,
          delay: i * 0.08,
          ease: [0.25, 0.1, 0.25, 1]
        }} className="flex items-start gap-4 bg-white rounded-2xl p-5 md:p-6 border border-brown/5" style={{
          boxShadow: '0 2px 16px rgba(61,50,41,0.04), 0 1px 4px rgba(61,50,41,0.03)'
        }} data-id="element-517">
              <svg className="w-4 h-4 shrink-0 mt-1.5 text-terracotta" viewBox="0 0 16 16" fill="currentColor" data-id="element-518">
                <path d="M8 0L14.5 8L8 16L1.5 8L8 0Z" data-id="element-519" />
              </svg>
              <span className="font-serif text-brown text-lg md:text-xl leading-relaxed font-medium" data-id="element-520">
                {pain}
              </span>
            </motion.div>)}
        </div>

        {/* Closing card */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.7,
        ease: [0.25, 0.1, 0.25, 1]
      }} className="relative max-w-2xl mx-auto" data-id="element-521">
          <div className="rounded-3xl p-8 md:p-12 text-center border border-brown/10" style={{
          background: 'linear-gradient(160deg, #FFFFFF 0%, #FAF7F2 100%)',
          boxShadow: '0 12px 48px rgba(61,50,41,0.08)'
        }} data-id="element-522">
            {/* Accent line */}
            <div className="w-10 h-px bg-terracotta/40 mx-auto mb-6" data-id="element-523" />

            <p className="font-serif text-xl md:text-2xl text-brown leading-relaxed mb-2" data-id="element-524">
              You're not failing.
            </p>
            <p className="font-serif text-xl md:text-2xl text-brown leading-relaxed" data-id="element-525">
              You're just missing a structure that protects{' '}
              <span className="text-terracotta italic" data-id="element-526">you</span>.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}